export enum StatusOnEmpty {
  Loading = 'loading',
  Disabled = 'disabled',
  Hidden = 'hidden',
}
